// // // // // // // // import { Navigate } from "react-router-dom";

// // // // // import { useSelector } from "react-redux";
// // // // // import { Navigate } from "react-router-dom";

// // // // // // // // const isAuthenticated = () => {
// // // // // // // //     return true; // Change to 'true' to simulate an authenticated user
// // // // // // // //   };
  
// // // // // // // //   // Protected Route Component
// // // // // // // //   const ProtectedRoute = ({ element: Element, ...rest }) => {
// // // // // // // //     return isAuthenticated() ? <Element {...rest} /> : <Navigate to="/" />;
// // // // // // // //   };

// // // // // // // //   export default ProtectedRoute;

// // // // // // // import React from 'react';
// // // // // // // import { Navigate, Route, Routes } from 'react-router-dom';
// // // // // // // import { useSelector } from 'react-redux';

// // // // // // // const ProtectedRoute = ({ element, ...rest }) => {
// // // // // // //   const { isAuthenticated } = useSelector((state) => state.auth);
// // // // // // //   console.log(isAuthenticated,"isAuthenticated")

// // // // // // //   if (!isAuthenticated) {
// // // // // // //     return <Navigate to="/login" />;
// // // // // // //   }

// // // // // // //   return element ;
// // // // // // // };

// // // // // // // export default ProtectedRoute;


// // // // // // import React from 'react';
// // // // // // import { Route, Navigate } from 'react-router-dom';
// // // // // // import { useSelector } from 'react-redux';
// // // // // // import rolePermissions from '../utils/rolePermissions';

// // // // // // const PrivateRoute = ({ element, allowedRoles, ...rest }) => {
// // // // // //   const { isLoggedIn, role } = useSelector((state) => state.auth);
// // // // // //   const permissions = rolePermissions[role];

// // // // // //   if (!isLoggedIn) {
// // // // // //     return <Navigate to="/login" />;
// // // // // //   }

// // // // // //   if (!permissions || !allowedRoles.some((role) => permissions.includes(role))) {
// // // // // //     return <Navigate to="/dashboard" />; // Redirect if no permission
// // // // // //   }

// // // // // //   return <Route {...rest} element={element} />;
// // // // // // };

// // // // // // export default PrivateRoute;

// // // // // const ProtectedRoute = ({ children, permission }) => {
// // // // //   const { isLoggedIn, permissions } = useSelector((state) => state.auth);

// // // // //   if (!isLoggedIn) {
// // // // //     console.warn('User not logged in');
// // // // //     return <Navigate to="/login" />;
// // // // //   }

// // // // //   // if (!permissions.includes(permission)) {
// // // // //   //   console.warn(`Permission "${permission}" not found for user`);
// // // // //   //   return <Navigate to="/dashboard" />;
// // // // //   // }

// // // // //   return children;
// // // // // };

// // // // // export default ProtectedRoute;



// // // // import React from 'react';
// // // // import { Navigate } from 'react-router-dom';
// // // // import { useSelector } from 'react-redux';

// // // // const ProtectedRoute = ({ children, permission }) => {
// // // //   const { isLoggedIn, permissions ,role} = useSelector((state) => state.auth);
// // // //   console.log(isLoggedIn,"isLogged nsdiasdsak")
// // // //   console.log(role,"role0230920-932")
  

// // // //   if (!isLoggedIn) {
// // // //     return <Navigate to="/" />;
// // // //   }

// // // //   // if (permission && !permissions.includes(permission)) {
// // // //   //   return <Navigate to="/dashboard" />;
// // // //   // }

// // // //   return children;
// // // // };

// // // // export default ProtectedRoute;


// // // import React from "react";
// // // import { Navigate, Outlet } from "react-router-dom";
// // // import { useSelector } from "react-redux";

// // // const ProtectedRoute = ({ module, page, action }) => {
// // //     const { isAuthenticated, permissions } = useSelector((state) => state.auth);
// // //     console.log(isAuthenticated,"isAuthenticatedisAuthenticated")
// // //     console.log(permissions,"permissionspermissions")
    

// // //     // Check if the user has the required permission
// // //     const hasPermission = permissions?.[module]?.[page]?.[action];
// // //     console.log(hasPermission,"hasPermission")

// // //     if (!isAuthenticated) return <Navigate to="/login" />;
// // //     if (!hasPermission) return <Navigate to="/dashboard" />;

// // //     return <Outlet />;
// // // };

// // // export default ProtectedRoute;



// // import React from "react";
// // import { Navigate, Outlet } from "react-router-dom";
// // import { useSelector } from "react-redux";

// // const ProtectedRoute = ({ module, page, action }) => {
// //     // const { isAuthenticated, permissions } = useSelector((state) => state.auth);
// //     const { isAuthenticated} = useSelector((state) => state.auth);

// //     const permissions = JSON.parse(localStorage.getItem("permissions"));

// //     console.log("Authenticated:", isAuthenticated);
// //     console.log("Permissions:", permissions);

// //     // Check if user is authenticated
// //     if (!isAuthenticated) {
// //         return <Navigate to="/login" />;
// //     }

// //     // Check if user has permission for the requested module, page, and action
// //     const hasPermission = permissions?.[module]?.[page]?.[action] ?? false;

// //     console.log(`Checking permission for: ${module} -> ${page} -> ${action}`);
// //     console.log("Has Permission:", hasPermission);

// //     if (!hasPermission) {
// //         return <Navigate to="/" />;
// //     }

// //     return <Outlet />;
// // };

// // export default ProtectedRoute;


// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useSelector } from "react-redux";

// const ProtectedRoute = ({ module, page, action, allowedRoles }) => {
//     const { isAuthenticated} = useSelector((state) => state.auth);
//     const permissions = JSON.parse(localStorage.getItem("permissions"));
//     const role = localStorage.getItem("role");


//     console.log("Authenticated:", isAuthenticated);
//     console.log("User Role:", role);
//     console.log("Permissions:", permissions);

//     // Check if user is authenticated
//     if (!isAuthenticated) {
//         return <Navigate to="/login" />;
//     }

//     // Check if user has permission for the requested module, page, and action
//     const hasPermission = permissions?.[module]?.[page]?.[action] ?? false;

//     // Check if user role is allowed
//     // const hasRoleAccess = allowedRoles.length === 0 || allowedRoles.includes(role);
//     const hasRoleAccess = allowedRoles === role;

//     console.log(hasRoleAccess,"hasssssssss")
    

//     console.log(`Checking permission for: ${module} -> ${page} -> ${action}`);
//     console.log("Has Permission:", hasPermission);
//     console.log("Has Role Access:", hasRoleAccess);

//     if (!hasPermission || !hasRoleAccess) {
//         return <Navigate to="/" />;
//     }

//     return <Outlet />;
// };

// export default ProtectedRoute;



import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ module, page, action, allowedRoles }) => {
    const { isAuthenticated, role } = useSelector((state) => state.auth);

    // Fetch permissions from localStorage (or ideally, from Redux)
    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    console.log("Authenticated:", isAuthenticated);
    console.log("User Role:", role);
    console.log("Permissions:", permissions);

    // Check if user is authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    // Check if role-based access is required
    if (allowedRoles && !allowedRoles.includes(role)) {
        console.log(`Access denied for role: ${role}`);
        return <Navigate to="/" />;
    }

    // Check if permission-based access is required
    if (module && page && action) {
        const hasPermission = permissions?.[module]?.[page]?.[action] ?? false;

        console.log(`Checking permission for: ${module} -> ${page} -> ${action}`);
        console.log("Has Permission:", hasPermission);

        if (!hasPermission) {
            return <Navigate to="/" />;
        }
    }

    return <Outlet />;
};

export default ProtectedRoute;
